const TokenKey = 'loginToken'
//从本地获取token
export function getToken() {
  return localStorage.getItem(TokenKey);
}
// 设置token到本地
export function setToken (token) {
  return localStorage.setItem(TokenKey, token)
}
// 删除本地token
export function removeToken () {
  return localStorage.removeItem(TokenKey);
}


//从本地获取昵称
export function getNickName() {
  return localStorage.getItem("nickName");
}
//从本地获取头像
export function getHeadImg() {
  return localStorage.getItem("HeadImg");
}
//从本地获取电话
export function getMobile() {
  return localStorage.getItem("Mobile");
}

//设置本地昵称
export function  setNickName(nickName) {
  return localStorage. setItem("nickName",nickName);
}
//设置本地头像
export function  setHeadImg(HeadImg) {
  return localStorage. setItem("HeadImg",HeadImg);
}
//设置本地电话
export function  setMobile(Mobile) {
  return localStorage. setItem("Mobile",Mobile);
}


//从本地获取Token过期时间
export function getExpTime() {
  return localStorage.getItem("ExpTime");
}
//设置本地Token过期时间
export function  setExpTime(ExpTime) {
  return localStorage. setItem("ExpTime",ExpTime);
}



//从本地获取用户类型
export function getUserType() {
  return localStorage.getItem("UserType");
}
//设置本地用户类型
export function  setUserType(UserType) {
  return localStorage. setItem("UserType",UserType);
}


export function getGUID () {
  let GUID = localStorage.getItem("GUID");
  if (GUID && GUID != '') { 
    return GUID;
  }  
  GUID = (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
  localStorage. setItem("GUID",GUID);
  return GUID;
}

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}


